import { Grid } from '@material-ui/core';
import { isEmpty } from 'lodash-es';
import React from 'react';

import { IUser } from '~/src/dash/api/console-api';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';
import { IASMeasurementTrackEvent } from '~/src/dash/views/measurement/common/consts';

interface IMeasurementFiltersPillProps {
  user: IUser;
  menuTitle: string;
  list: IMenuList;
  handleFilterOnChange: (menuTitle: string) => (values: IMenuList) => void;
  // tooltipText?: string;
  handleFilterAccept: () => void;
}

export const MeasurementFiltersPill = ({
  user,
  menuTitle,
  list,
  handleFilterOnChange,
  handleFilterAccept,
}: IMeasurementFiltersPillProps) => {
  const numSelected = Object.values(list).filter((item) => item.selected).length;
  const updatedMenuTitle = numSelected > 1 ? menuTitle : menuTitle.slice(0, menuTitle.length - 1);
  if (isEmpty(list)) {
    return null;
  }
  return (
    <Grid
      style={{
        height: '100%',
        border: `1px solid ${publicaColors.lightGray}`,
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 8,
        marginRight: 16,
        borderRadius: 25,
        backgroundColor: numSelected ? publicaColors.lightTeal : publicaColors.veryLightGray,
        maxWidth: 250,
      }}
    >
      <MaterialSearchDropdownMulti
        disabled={false}
        fontSize='12px'
        menuTitle={updatedMenuTitle}
        list={list}
        onChange={handleFilterOnChange(menuTitle)}
        handleMenuAcceptClick={handleFilterAccept}
        menuTitleOverride={updatedMenuTitle}
        onlyShowNumberWhenClosed={true}
        maxHeight={350}
        selectAll={false}
        disableBottomBorder={true}
        onOpen={() =>
          IASMeasurementTrackEvent(user, {
            eventTitle: 'IAS Measurement Drill Dashboard - Open Filter Pill',
          })
        }
      />
    </Grid>
  );
};
